import axios from "axios";
import { currentDate } from "../utils/utils";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const GET_LOCATIONS = process.env.REACT_APP_LOCATIONS;
const GET_TIME = process.env.REACT_APP_TIME;
const GET_ZONE = process.env.REACT_APP_ZONE;
export const API_KEY = process.env.REACT_APP_GMAPS_API_KEY;

export const getLocations = async () => {
  const getLocationRequest = await axios.get(`${BASE_URL}${GET_LOCATIONS}`);
  const data = getLocationRequest.data;
  //console.log({locations: data})
  return data;
};

export async function getPrayerTime(timeCode) {
  const code = "?code=" + timeCode;
  const date = "&date=" + currentDate();
  const param = code + "" + date;
  const getPrayerTimesRequest = await axios.get(
    `${BASE_URL}${GET_TIME}${param}`,
  );
  const data = getPrayerTimesRequest.data;
  //console.log({ prayer: data })
  return data;
}

export async function getZone(country, state, town, town2) {
  const pCountry = "?country=" + country;
  const pState = "&state=" + state;
  const pTown = "&town=" + town;
  const pTown2 = "&town2=" + town2;
  const param = pCountry + "" + pState + "" + pTown + "" + pTown2;
  const getZoneRequest = await axios.get(`${BASE_URL}${GET_ZONE}${param}`);
  const data = getZoneRequest.data;
  return data;
}
